module.exports = __webpack_public_path__ + "1.4.15-unryo/img/step4.47ea8c0f.png";